import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { compose, withProps } from 'recompose';
import browserHistory from 'react-router/lib/browserHistory';

import Button from '../Button';
import { AUTH } from '../../constants/strings';
import { WEB_APP_URL } from '../../constants/env';
import { EXPIRED_LINK, LOGIN } from '../../constants/routes';
import { currentLocationSelector } from '../../redux/common/selectors';

import styles from './index.styl';
import MetaHelmet from '../AppHelmet/MetaHelmet';
import { usePageView } from '../../hocs/usePageView';

const ExpiredLink = ({ description, values }) => {
  usePageView('Expired Link');
  return (
    <div className={styles.formWrapper}>
      <MetaHelmet title="pages.title.expiredLink" />

      <p className={styles.formContent}>
        <FormattedMessage id={description} values={values} />
      </p>
      <Button
        className="db w-100"
        color="primary"
        raised
        onClick={() => browserHistory.push(LOGIN)}
      >
        <FormattedMessage {...AUTH.submit.expiredToken} />
      </Button>
    </div>
  );
};

ExpiredLink.propTypes = {
  values: PropTypes.object,
  description: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  location: currentLocationSelector(state),
});

export default compose(
  connect(mapStateToProps),
  withProps(({ location }) => {
    if (location === `/${EXPIRED_LINK}`) {
      return {
        description: 'auth.expiredLink.text',
        values: {
          link: (
            <a href={WEB_APP_URL} className="clickable">
              {WEB_APP_URL}
            </a>
          ),
        },
      };
    }
    return { description: 'auth.expiredLinkDefault.text' };
  }),
)(ExpiredLink);



// WEBPACK FOOTER //
// ./src/components/Auth/ExpiredLink.jsx